/**
 * Gearbox toggle on the vehicle list: shows all, manual or automatic vehicles and keeps the count in step.
 */
module.exports = function () {
    document.querySelectorAll('.vehicle-list-1').forEach(function (list) {
        const buttons = Array.from(list.querySelectorAll('[data-gearbox]'));
        const items = Array.from(list.querySelectorAll('[data-gearbox-item]'));
        const count = list.querySelector('[data-gearbox-count]');

        if (!buttons.length)
            return;

        const noun = count ? count.dataset.noun : 'vehicle';

        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                const value = button.dataset.gearbox;

                buttons.forEach(function (other) {
                    const on = other === button;
                    other.classList.toggle('active', on);
                    other.setAttribute('aria-pressed', on ? 'true' : 'false');
                });

                let shown = 0;
                items.forEach(function (item) {
                    const hide = value !== 'all' && item.dataset.gearboxItem !== value;
                    item.classList.toggle('d-none', hide);
                    if (!hide)
                        shown++;
                });

                if (count)
                    count.textContent = shown + ' ' + noun + (shown === 1 ? '' : 's');
            });
        });
    });
};
